var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTgButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 160.01,
    x2: 100.01,
    y1: 40.008,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37aee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e96c8"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m44.691 125.87c14.028-7.7268 29.687-14.176 44.318-20.658 25.171-10.617 50.442-21.05 75.968-30.763 4.9664-1.6549 13.89-3.2731 14.765 4.0866-0.47934 10.418-2.4503 20.775-3.8021 31.132-3.4313 22.776-7.3975 45.474-11.265 68.175-1.3326 7.5618-10.805 11.476-16.866 6.6369-14.566-9.8386-29.244-19.582-43.624-29.649-4.7105-4.7863-0.34239-11.66 3.8645-15.078 11.997-11.823 24.72-21.868 36.09-34.302 3.067-7.4061-5.9951-1.1645-8.9842 0.74815-16.424 11.318-32.446 23.327-49.762 33.274-8.845 4.8689-19.154 0.70809-27.995-2.0087-7.9269-3.2821-19.543-6.5888-12.708-11.593z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgButton);
export default __webpack_public_path__ + "static/media/tg_button.6f75062a3990e6e92e2083e148acd440.svg";
export { ForwardRef as ReactComponent };